var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHandleOrder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "xiadan-3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u4F1A\\u6240\\u7CFB\\u7EDFUI\\u754C\\u9762",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6253\\u4F4D\\u7BA1\\u7406/\\u8BA2\\u5355/\\u8FD4\\u573A\\u5907\\u4EFD",
    transform: "translate(-1298.000000, -559.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-5",
    transform: "translate(232.000000, 143.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-3",
    transform: "translate(1052.000000, 406.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "xiadan-3",
    transform: "translate(14.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7160648,14 C11.5765878,14 11.4371108,13.93 11.3673724,13.79 L9.55417186,11.69 C9.48443337,11.55 9.48443337,11.41 9.55417186,11.27 C9.62391034,11.13 9.7633873,11.06 9.97260274,11.06 L10.8094645,11.06 L10.8094645,9.1 C10.8094645,8.89 11.01868,8.68 11.2278954,8.68 L12.2739726,8.68 C12.483188,8.68 12.6924035,8.89 12.6924035,9.1 L12.6924035,11.06 L13.5292653,11.06 C13.6687422,11.06 13.8082192,11.13 13.9476961,11.27 C14.0174346,11.41 14.0174346,11.62 13.9476961,11.76 L12.1344956,13.79 C11.9950187,13.93 11.8555417,14 11.7160648,14 L11.7160648,14 Z M0.97633873,0.98 L10.9489415,0.98 L10.9489415,5.95 L11.9252802,5.95 L11.9252802,0.98 C11.9252802,0.42 11.5068493,0 10.9489415,0 L0.97633873,0 C0.418430884,0 0,0.42 0,0.98 L0,10.99 C0,11.55 0.418430884,11.97 0.97633873,11.97 L6.97384807,11.97 L6.97384807,10.99 L0.97633873,10.99 L0.97633873,0.98 Z",
    id: "\\u5F62\\u72B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,3 L9,3 L9,4.05660377 L3,4.05660377 L3,3 Z M3,5.94339623 L9,5.94339623 L9,7 L3,7 L3,5.94339623 Z",
    id: "\\u5F62\\u72B6"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandleOrder);
export default __webpack_public_path__ + "static/media/handle-order.79dac8cc4cbd92810de27329f3b5469a.svg";
export { ForwardRef as ReactComponent };